const capitalize = value => value.charAt(0).toUpperCase() + value.slice(1);
const getInitialLetter = string => {
  if (string) {
    return string.substr(0, 1)?.toUpperCase();
  }
  return 'U';
};

export { capitalize, getInitialLetter };
